// Mock data for All Saints Catholic Parish

export const HERO_IMAGE = 'https://images.unsplash.com/photo-1590448104306-03e12eecc878?fit=crop&crop=entropy&auto=format&w=1800&q=85';

export const CHURCH_IMAGES = {
  stMary: 'https://images.unsplash.com/photo-1511527661048-7fe73d85e9a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxjYXRob2xpYyUyMGNodXJjaHxlbnwwfHx8fDE3ODU4OTk1MTV8MA&ixlib=rb-4.1.0&q=85&w=1200',
  stJoseph: 'https://images.unsplash.com/photo-1465848059293-208e11dfea17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxjYXRob2xpYyUyMGNodXJjaHxlbnwwfHx8fDE3ODU4OTk1MTV8MA&ixlib=rb-4.1.0&q=85&w=1200',
  interior: 'https://images.unsplash.com/photo-1491566102020-21838225c3c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxjYXRob2xpYyUyMGNodXJjaHxlbnwwfHx8fDE3ODU4OTk1MTV8MA&ixlib=rb-4.1.0&q=85&w=1200',
};

export const SACRAMENT_IMAGES = {
  baptism: 'https://images.unsplash.com/photo-1566516171511-1c411a59c8ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxiYXB0aXNtfGVufDB8fHx8MTc4NTg5OTUxNXww&ixlib=rb-4.1.0&q=85&w=900',
  communion: 'https://images.unsplash.com/photo-1520629716099-d147346eb224?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxjb21tdW5pb258ZW58MHx8fHwxNzg1ODk5NTE1fDA&ixlib=rb-4.1.0&q=85&w=900',
  confirmation: 'https://images.unsplash.com/photo-1531627467965-e9c3dd19209c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxjb21tdW5pb258ZW58MHx8fHwxNzg1ODk5NTE1fDA&ixlib=rb-4.1.0&q=85&w=900',
  marriage: 'https://images.unsplash.com/photo-1548625149-fc4a29cf7092?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwY2h1cmNofGVufDB8fHx8MTc4NTg5OTUyMXww&ixlib=rb-4.1.0&q=85&w=900',
  confession: 'https://images.unsplash.com/photo-1610131635230-9c4afb6238b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxjb21tdW5pb258ZW58MHx8fHwxNzg1ODk5NTE1fDA&ixlib=rb-4.1.0&q=85&w=900',
  anointing: 'https://images.unsplash.com/photo-1543525238-54e3d131f7ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxwcmF5ZXJ8ZW58MHx8fHwxNzg1ODk5NTIwfDA&ixlib=rb-4.1.0&q=85&w=900',
  funeral: 'https://images.unsplash.com/photo-1592708488730-0444f89ee75e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHw0fHxjb21tdW5pb258ZW58MHx8fHwxNzg1ODk5NTE1fDA&ixlib=rb-4.1.0&q=85&w=900',
  'holy-orders': 'https://images.unsplash.com/photo-1437603568260-1950d3ca6eab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxwcmF5ZXJ8ZW58MHx8fHwxNzg1ODk5NTIwfDA&ixlib=rb-4.1.0&q=85&w=900',
};

export const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'Mass Times', path: '/mass-times' },
  { label: 'Bulletin', path: '/bulletin' },
  {
    label: 'Parish Life',
    path: '/parish-life',
    children: [
      { label: 'Overview', path: '/parish-life' },
      { label: 'About', path: '/about' },
      { label: "I'm New", path: '/parish-life/im-new' },
      { label: 'Ministries & Programs', path: '/parish-life/ministries' },
      { label: 'Parish Calendar', path: '/parish-life/calendar' },
      { label: 'News & Resources', path: '/parish-life/news' },
      { label: 'Hall Rental', path: '/parish-life/hall-rental' },
    ],
  },
  {
    label: 'Sacraments',
    path: '/sacraments',
    children: [
      { label: 'All Sacraments', path: '/sacraments' },
      { label: 'Baptism', path: '/sacraments/baptism' },
      { label: 'First Communion', path: '/sacraments/first-communion' },
      { label: 'Confirmation', path: '/sacraments/confirmation' },
      { label: 'Confession', path: '/sacraments/confession' },
      { label: 'Anointing of the Sick', path: '/sacraments/anointing-of-the-sick' },
      { label: 'Marriage', path: '/sacraments/marriage' },
      { label: 'Holy Orders', path: '/sacraments/holy-orders' },
    ],
  },
  {
    label: 'Giving',
    path: '/give',
    children: [
      { label: 'Overview', path: '/give' },
      { label: 'Online Donation', path: '/give/online' },
      { label: 'Automatic Debits', path: '/give/automatic' },
      { label: 'Weekly Envelopes', path: '/give/envelopes' },
    ],
  },
  { label: 'Contact', path: '/contact', children: [
      { label: 'Contact', path: '/contact' },
      { label: 'Register as a Parishioner', path: '/new-parishioner' },
      { label: 'Prayer Requests', path: '/prayer-request' },
      { label: 'Funeral Planning', path: '/parish-life/funeral' },
    ],
  },
];

export const HELPFUL_LINKS = [
  { title: 'Archdiocese of Vancouver', url: 'https://rcav.org', description: 'Our diocesan home for news, events, and resources across the archdiocese.' },
  { title: 'Daily Mass Readings', url: 'https://bible.usccb.org/daily-bible-reading', description: 'The daily Scripture readings from the USCCB.' },
  { title: 'Vatican News', url: 'https://www.vaticannews.va/en.html', description: 'News, teachings, and messages from the Holy See.' },
  { title: 'Catechism of the Catholic Church', url: 'https://www.vatican.va/archive/ENG0015/_INDEX.HTM', description: 'The complete Catechism of the Catholic Church, freely searchable online.' },
  { title: 'Canadian Conference of Catholic Bishops', url: 'https://www.cccb.ca', description: 'The national assembly of Catholic bishops in Canada.' },
  { title: 'Development and Peace', url: 'https://devp.org', description: "The Canadian Catholic Church's official international development organization." },
];

export const QUICK_ACTIONS = [
  { title: 'Bulletin', description: 'Read the weekly parish bulletin and updates', icon: 'FileText', path: '/bulletin' },
  { title: "I'm New", description: 'Just arrived or exploring the Catholic Faith? Start here', icon: 'Sparkles', path: '/parish-life/im-new' },
  { title: 'Registration', description: 'New to the parish? Register with our community', icon: 'UserPlus', path: '/new-parishioner' },
  { title: 'Giving', description: 'Support our parish mission through joyful giving', icon: 'HeartHandshake', path: '/give' },
];

export const CHURCHES = [
  {
    id: 'st-marys',
    name: "St. Mary's Church",
    community: 'Ladysmith',
    address: '1135 4th Ave, Ladysmith, BC V9G 1Z2',
    phone: '(250) 245-3714',
    image: 'https://images.unsplash.com/photo-1511527661048-7fe73d85e9a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxjYXRob2xpYyUyMGNodXJjaHxlbnwwfHx8fDE3ODU4OTk1MTV8MA&ixlib=rb-4.1.0&q=85&w=1200',
    schedule: [
      { day: 'Saturday', time: '5:00 PM', label: 'Anticipated Sunday Mass' },
      { day: 'Sunday', time: '10:30 AM', label: 'Sunday Mass' },
      { day: 'Tuesday & Thursday', time: '9:00 AM', label: 'Weekday Mass' },
      { day: 'Saturday', time: '4:15 – 4:45 PM', label: 'Confessions' },
    ],
  },
  {
    id: 'st-josephs',
    name: "St. Joseph's Church",
    community: 'Chemainus',
    address: '9714 Chemainus Rd, Chemainus, BC V0R 1K0',
    phone: '(250) 246-3191',
    image: 'https://images.unsplash.com/photo-1465848059293-208e11dfea17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxjYXRob2xpYyUyMGNodXJjaHxlbnwwfHx8fDE3ODU4OTk1MTV8MA&ixlib=rb-4.1.0&q=85&w=1200',
    schedule: [
      { day: 'Sunday', time: '8:30 AM', label: 'Sunday Mass' },
      { day: 'Wednesday & Friday', time: '9:00 AM', label: 'Weekday Mass' },
      { day: 'First Friday', time: '9:30 AM – 10:30 AM', label: 'Adoration' },
      { day: 'Saturday', time: '9:30 – 10:00 AM', label: 'Confessions' },
    ],
  },
];

export const NEWS_ITEMS = [
  {
    id: 1,
    date: 'This Sunday',
    title: 'Coffee & Fellowship After Mass',
    excerpt: 'Join us in the parish hall after the 10:30 AM Mass at St. Mary\'s for coffee, treats, and warm conversation with fellow parishioners.',
  },
  {
    id: 2,
    date: 'August 15',
    title: 'Solemnity of the Assumption',
    excerpt: 'A Holy Day of Obligation. Special Mass at 7:00 PM at St. Mary\'s and 9:00 AM at St. Joseph\'s.',
  },
  {
    id: 3,
    date: 'Ongoing',
    title: 'New Parishioner Welcome',
    excerpt: 'Are you new to the parish? Introduce yourself to our pastor after Mass or fill out our online registration form.',
  },
];

export const BULLETINS = [
  { id: 1, date: 'August 3, 2026', title: '18th Sunday in Ordinary Time', size: '820 KB' },
  { id: 2, date: 'July 27, 2026', title: '17th Sunday in Ordinary Time', size: '780 KB' },
  { id: 3, date: 'July 20, 2026', title: '16th Sunday in Ordinary Time', size: '810 KB' },
  { id: 4, date: 'July 13, 2026', title: '15th Sunday in Ordinary Time', size: '790 KB' },
  { id: 5, date: 'July 6, 2026', title: '14th Sunday in Ordinary Time', size: '765 KB' },
  { id: 6, date: 'June 29, 2026', title: 'Sts. Peter and Paul, Apostles', size: '800 KB' },
];

export const SACRAMENTS = [
  { slug: 'baptism', title: 'Baptism', description: 'Saving waters that bring the Holy Spirit and welcome Catholics into the Church.', icon: 'Droplets' },
  { slug: 'first-communion', title: 'First Communion', description: 'Receiving the Body, Blood, Soul, and Divinity of Jesus Christ in the Eucharist for the first time.', icon: 'Wheat' },
  { slug: 'confirmation', title: 'Confirmation', description: 'Being sealed and strengthened by the gift of the Holy Spirit to be a living witness to Christ.', icon: 'Flame' },
  { slug: 'confession', title: 'Confession', description: "Experiencing God's mercy exercised through the ministry of priests.", icon: 'BookOpenCheck' },
  { slug: 'anointing-of-the-sick', title: 'Anointing of the Sick', description: 'Bringing spiritual strength to those who are ill or close to death.', icon: 'HandHeart' },
  { slug: 'marriage', title: 'Marriage', description: 'Celebrating the sacred union between a man and woman as husband and wife.', icon: 'Rings' },
  { slug: 'holy-orders', title: 'Holy Orders', description: 'The sacrament of ordained ministry — bishops, priests, and deacons who serve the People of God.', icon: 'Church' },
];

export const MINISTRIES = [
  { slug: 'altar-servers', name: 'Altar Servers', description: 'Young parishioners assisting the priest at the altar during Mass.', category: 'Liturgical' },
  { slug: 'lectors', name: 'Lectors', description: 'Proclaiming the Word of God at Mass with reverence and clarity.', category: 'Liturgical' },
  { slug: 'music', name: 'Music Ministry', description: 'Leading the parish in sung prayer at weekend Masses.', category: 'Liturgical' },
  { slug: 'hospitality', name: 'Hospitality', description: 'Welcoming parishioners and visitors before and after Mass.', category: 'Community' },
  { slug: 'cwl', name: "Catholic Women's League", description: 'A national organization of Catholic women serving parish and community.', category: 'Community' },
  { slug: 'knights', name: 'Knights of Columbus', description: 'Catholic men serving through charity, unity, and fraternity.', category: 'Community' },
  { slug: 'prep', name: 'PREP Catechism', description: 'Faith formation classes for children preparing for the sacraments.', category: 'Faith Formation' },
  { slug: 'rcia', name: 'RCIA', description: 'Rite of Christian Initiation of Adults — becoming Catholic.', category: 'Faith Formation' },
  { slug: 'bible-study', name: 'Bible Study', description: 'Weekly gatherings to grow in Scripture together as a community.', category: 'Faith Formation' },
  { slug: 'youth', name: 'Youth Group', description: 'Faith, friendship, and service for parish teens.', category: 'Faith Formation' },
  { slug: 'st-vincent', name: 'St. Vincent de Paul Society', description: 'Outreach to those in need in our local Ladysmith and Chemainus communities.', category: 'Outreach' },
  { slug: 'prayer-shawl', name: 'Prayer Shawl Ministry', description: 'Handmade shawls given with prayer to those needing comfort.', category: 'Outreach' },
];

export const CLERGY = [
  {
    name: 'Fr. Sebastian Michael',
    role: 'Pastor',
    bio: 'Fr. Sebastian has served the parish community of All Saints since 2022, shepherding both St. Mary\'s and St. Joseph\'s congregations with pastoral warmth.',
  },
  {
    name: 'Deacon Robert Fournier',
    role: 'Permanent Deacon',
    bio: 'Deacon Robert assists at the altar, in preaching, and in the parish\'s ministry of charity, having served the community for over a decade.',
  },
];

export const STAFF = [
  { name: 'Anne Marie Delaney', role: 'Parish Office Administrator' },
  { name: 'Michael Corbett', role: 'Music Director – St. Mary\'s' },
  { name: 'Elena Rodriguez', role: 'PREP Coordinator' },
  { name: 'James O\'Sullivan', role: 'Bookkeeper' },
];

export const MISSION_VERSE = {
  text: 'Go therefore and make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit, and teaching them to obey everything that I have commanded you. And remember, I am with you always, to the end of the age.',
  citation: 'Matthew 28:19–20',
};

export const LAND_ACKNOWLEDGMENT = 'All Saints Catholic Parish is situated on the traditional and unceded territories of the Stz\'uminus and Halalt First Nations. We give thanks for the enduring stewardship of these lands by the Coast Salish peoples and commit ourselves to walking together in truth, respect, and reconciliation.';
